import OhlinsPage from "./pages/OhlinsPage";
import { Routes, Route, Link } from "react-router-dom";
import { HomePage } from "./pages/HomePage.js";
import { SearchPage } from "./pages/SearchPage.js";
import { PartSearchPage } from "./pages/PartSearchPage.js";
import { ModelDetailPage } from "./pages/ModelDetailPage.js";
import { DrawingPage } from "./pages/DrawingPage.js";
import { PartDetailPage } from "./pages/PartDetailPage.js";
import { PowerpartsPage } from "./pages/PowerpartsPage.js";
import { PowerWearPage } from "./pages/PowerWearPage.js";
import { CollectionsPage } from "./pages/CollectionsPage.js";
import { MefoPage } from "./pages/MefoPage.js";
import { MefoDetailPage } from "./pages/MefoDetailPage.js";
import { MotorexPage } from "./pages/MotorexPage.js";
import { MotorexDetailPage } from "./pages/MotorexDetailPage.js";
import { GarminPage } from "./pages/GarminPage.js";
import { GarminDetailPage } from "./pages/GarminDetailPage.js";
import { QuoteDetailPage } from "./pages/QuoteDetailPage.js";
import { QuotesListPage } from "./pages/QuotesListPage.js";
import { FtpAdminPage } from "./pages/admin/FtpAdminPage.js";
import { WarehousesAdminPage } from "./pages/admin/WarehousesAdminPage.js";
import { IntegrationsPage } from "./pages/admin/IntegrationsPage.js";
import { AutomationsPage } from "./pages/admin/AutomationsPage.js";
import { CustomersPage } from "./pages/admin/CustomersPage.js";
import { CustomerDetailPage } from "./pages/admin/CustomerDetailPage.js";
import { B2bikeAdminPage } from "./pages/admin/B2bikeAdminPage.js";
import { ZdrojePage } from "./pages/admin/ZdrojePage.js";
import { B2bikePage } from "./pages/B2bikePage.js";
import { RiskPage } from "./pages/RiskPage.js";
import { AzpneuPage } from "./pages/AzpneuPage.js";
import { AzpneuDetailPage } from "./pages/AzpneuDetailPage.js";
import { Sg12Page } from "./pages/Sg12Page.js";
import { Sg12DetailPage } from "./pages/Sg12DetailPage.js";
import { AngelswheelsPage } from "./pages/AngelswheelsPage.js";
import { AngelswheelsDilPage } from "./pages/AngelswheelsDilPage.js";
import { AngelswheelsKoloPage } from "./pages/AngelswheelsKoloPage.js";
import { AdrenalinPage } from "./pages/AdrenalinPage.js";
import { AdrenalinDetailPage } from "./pages/AdrenalinDetailPage.js";
import { RiskDetailPage } from "./pages/RiskDetailPage.js";
import { B2bikeDetailPage } from "./pages/B2bikeDetailPage.js";
import { VatToggle, CurrencyToggle } from "./ui/PriceDisplay.js";
import { CartButton } from "./ui/CartButton.js";
import { LocaleToggle } from "./ui/LocaleToggle.js";
import { CartDrawer } from "./ui/CartDrawer.js";
import { FtpPendingBanner } from "./ui/FtpPendingBanner.js";
import { NavMenu, CATALOG, PROVOZ } from "./ui/NavMenu.js";
import { UserIcon, MotorcycleIcon, HashIcon } from "./lib/icons.js";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext.js";
import { LoginPage } from "./pages/LoginPage.js";
import { useState, useRef, useEffect } from "react";

/**
 * Root layout — dvou-úrovňový header (brand row + nav row), KTM branding.
 * AuthGate: pokud je AUTH_ENABLED a uživatel není přihlášen → LoginPage.
 */
export function App(): JSX.Element {
  const { loading, authEnabled, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <div className="text-zinc-500 text-sm">Načítám…</div>
      </div>
    );
  }

  if (authEnabled && !user) {
    return <LoginPage />;
  }

  return (
    <div className="min-h-full flex flex-col bg-zinc-50">
      <TopBar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search/model" element={<SearchPage />} />
          <Route path="/search/part" element={<PartSearchPage />} />
          <Route path="/model/:modelId" element={<ModelDetailPage />} />
          <Route
            path="/model/:modelId/drawing/:subgroupId"
            element={<DrawingPage />}
          />
          <Route path="/part/:articleNumber" element={<PartDetailPage />} />
          <Route path="/powerparts" element={<PowerpartsPage />} />
          <Route path="/powerwear" element={<PowerWearPage />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/mefo" element={<MefoPage />} />
          <Route path="/mefo/:itemId" element={<MefoDetailPage />} />
          <Route path="/motorex" element={<MotorexPage />} />
          <Route path="/motorex/:itemId" element={<MotorexDetailPage />} />
          <Route path="/azpneu" element={<AzpneuPage />} />
          <Route path="/azpneu/:brand/:pattern" element={<AzpneuDetailPage />} />
          <Route path="/sg12" element={<Sg12Page />} />
          <Route path="/sg12/:ref" element={<Sg12DetailPage />} />
          <Route path="/angelswheels" element={<AngelswheelsPage />} />
          <Route path="/angelswheels/kola/:key" element={<AngelswheelsKoloPage />} />
          <Route path="/angelswheels/dily/:ref" element={<AngelswheelsDilPage />} />
          <Route path="/adrenalin" element={<AdrenalinPage />} />
          <Route path="/ohlins" element={<OhlinsPage />} />
          <Route path="/adrenalin/:supplierId" element={<AdrenalinDetailPage />} />
          <Route path="/risk" element={<RiskPage />} />
          <Route path="/risk/:sku" element={<RiskDetailPage />} />
          <Route path="/garmin" element={<GarminPage />} />
          <Route path="/garmin/:code" element={<GarminDetailPage />} />
          <Route path="/quotes" element={<QuotesListPage />} />
          <Route path="/quote/:id" element={<QuoteDetailPage />} />
          <Route path="/admin/integrations" element={<IntegrationsPage />} />
          <Route path="/admin/automations" element={<AutomationsPage />} />
          <Route path="/admin/customers" element={<CustomersPage />} />
          <Route path="/admin/customers/:id" element={<CustomerDetailPage />} />
          <Route path="/admin/b2bike" element={<B2bikeAdminPage />} />
          <Route path="/b2bike" element={<B2bikePage />} />
          <Route path="/b2bike/:id" element={<B2bikeDetailPage />} />
          <Route path="/admin/ftp" element={<FtpAdminPage />} />
          <Route path="/admin/warehouses" element={<WarehousesAdminPage />} />
          <Route path="/admin/zdroje" element={<ZdrojePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}

function TopBar(): JSX.Element {
  const { user, authEnabled, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobilOpen, setMobilOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const { pathname } = useLocation();

  // Po přechodu na jinou stránku menu zavřít — jinak zůstane viset přes obsah.
  useEffect(() => {
    setMobilOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!menuOpen) return;
    function onClick(e: MouseEvent): void {
      if (!menuRef.current?.contains(e.target as Node)) setMenuOpen(false);
    }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [menuOpen]);

  async function handleLogout(): Promise<void> {
    setMenuOpen(false);
    await logout();
  }

  return (
    <header className="bg-ktm-black text-white sticky top-0 z-40 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/*
          Na mobilu se logo + menu + čtyři přepínače do jedné řady nevejdou.
          Bez `flex-wrap` z toho lezl vodorovný posuvník přes CELOU aplikaci
          (změřeno 15. 8. 2026: přetékalo o 430 px na všech stránkách).
          Proto se řada smí zalomit a `h-14` je jen minimum, ne pevná výška.
        */}
        <div className="min-h-14 py-1.5 sm:py-0 flex items-center justify-between gap-2 sm:gap-6 flex-wrap border-b border-white/5">
          <Link to="/" className="flex items-center gap-3 group shrink-0" aria-label="KTM Vlašim — domů">
            <img
              src="/logo.svg"
              alt="KTM Vlašim"
              width={72}
              height={36}
              className="h-9 w-[72px] shrink-0 select-none transition-transform duration-150 group-hover:scale-[1.03]"
              draggable={false}
            />
          </Link>

          <NavMenu />

          {/*
            ⛔ Pod 640 px se přepínače schovávají do `MobileMenu` (níž). Do jedné
            řady se nevešly a zalomení sice posuvník spravilo, ale hlavička pak
            zabírala 205 px z 812 — čtvrtinu displeje (změřeno 15. 8. 2026).
          */}
          <div className="hidden sm:flex items-center gap-2 sm:gap-3 flex-wrap justify-end">
            <FtpPendingBanner />
            <LocaleToggle />
            <CurrencyToggle />
            <VatToggle />
            <CartButton />
            <div className="relative" ref={menuRef}>
              <button
                type="button"
                onClick={() => setMenuOpen((v) => !v)}
                className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 transition-colors flex items-center justify-center"
                aria-label="Uživatel"
                aria-expanded={menuOpen}
              >
                <UserIcon size={18} />
              </button>
              {menuOpen && (
                <div className="absolute right-0 top-full mt-2 w-56 bg-white text-zinc-800 rounded-lg shadow-lg ring-1 ring-zinc-200 overflow-hidden">
                  {user && (
                    <div className="px-4 py-3 border-b border-zinc-100">
                      <div className="text-sm font-medium truncate">
                        {user.name ?? user.id}
                      </div>
                      <div className="text-xs text-zinc-500 capitalize">
                        {user.role}
                      </div>
                    </div>
                  )}
                  {authEnabled ? (
                    <button
                      type="button"
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2.5 text-sm hover:bg-zinc-50 transition-colors text-red-600"
                    >
                      Odhlásit se
                    </button>
                  ) : (
                    <div className="px-4 py-2.5 text-xs text-zinc-500">
                      Auth je vypnutý (dev mode)
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Mobil: jen košík a hamburger — zbytek je v rozbalovacím panelu. */}
          <div className="flex sm:hidden items-center gap-1">
            <CartButton />
            <button
              type="button"
              onClick={() => setMobilOpen((v) => !v)}
              className="w-11 h-11 -mr-2 rounded-lg hover:bg-white/10 active:bg-white/20 transition-colors flex items-center justify-center"
              aria-label={mobilOpen ? "Zavřít menu" : "Otevřít menu"}
              aria-expanded={mobilOpen}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   strokeWidth="2" strokeLinecap="round">
                {mobilOpen ? (
                  <>
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </>
                ) : (
                  <>
                    <line x1="3" y1="6" x2="21" y2="6" />
                    <line x1="3" y1="12" x2="21" y2="12" />
                    <line x1="3" y1="18" x2="21" y2="18" />
                  </>
                )}
              </svg>
            </button>
          </div>
        </div>

        {/*
          🔑 Panel je BLOK v toku, ne plovoucí `absolute` — právě proto nemůže
          přetéct přes okraj. Rozbalovací menu `Katalog`/`Provoz` z počítačové
          verze bylo kotvené k tlačítku a lezlo 67 a 111 px za obrazovku.
        */}
        {mobilOpen && (
          <MobileMenu
            onZavri={() => setMobilOpen(false)}
            user={user}
            authEnabled={authEnabled}
            onLogout={handleLogout}
          />
        )}

        {user && user.id !== "system" && (
          <div className="hidden sm:flex h-9 items-center justify-between text-xs text-zinc-400">
            <div>
              <span className="text-zinc-300">{user.name ?? user.id}</span>
              <span className="mx-2 text-zinc-600">·</span>
              <span className="capitalize">{user.role}</span>
            </div>
            {authEnabled && (
              <button
                type="button"
                onClick={handleLogout}
                className="text-zinc-300 hover:text-white transition-colors flex items-center gap-1.5 group"
                aria-label="Odhlásit se"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="opacity-70 group-hover:opacity-100"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Odhlásit se
              </button>
            )}
          </div>
        )}
      </div>
    </header>
  );
}

// NavItem byl nahrazen komponentou <NavMenu /> v ui/NavMenu.tsx
// (kompaktní navigace s dropdown "Katalog" a "Provoz").

/**
 * Mobilní menu — všechno, co se na počítači vejde do hlavičky.
 *
 * 🔑 Je to BLOK v toku dokumentu, ne plovoucí panel. Proto se nemá jak dostat
 * za okraj obrazovky, na rozdíl od rozbalovacích menu na počítači.
 *
 * ⚠ Seznamy `CATALOG` a `PROVOZ` se sem VOZÍ z `NavMenu.tsx`. Kdyby se opsaly,
 * nový dodavatel by přibyl jen na počítači.
 */
function MobileMenu({
  onZavri,
  user,
  authEnabled,
  onLogout,
}: {
  onZavri: () => void;
  user: { id: string; name?: string; role: string } | null;
  authEnabled: boolean;
  onLogout: () => void | Promise<void>;
}): JSX.Element {
  const { pathname } = useLocation();

  /// 🔑 Otevřená je JEN ta skupina, ve které zrovna jsi. Ostatní jsou sbalené.
  /// Do 24. 8. 2026 byly rozbalené všechny naráz: 21 odkazů + 4 nadpisy
  /// + přepínače = **1 440 px**, tedy skoro dvě obrazovky na 375 × 812.
  /// „Provoz" začínal až pod ohybem a k „Odhlásit se" se muselo scrollovat.
  /// Vít 24. 8.: *„mobilní rozlišení gullsoftu — to menu je trošku takový
  /// krkolomný."*
  const vychozi = [...CATALOG.map((s) => s.label), "Provoz"].find((label) => {
    const cesty = label === "Provoz"
      ? PROVOZ.map((i) => i.to)
      : (CATALOG.find((s) => s.label === label)?.items ?? []).map((i) => i.to);
    return cesty.some((c) => pathname.startsWith(c));
  });
  const [otevrena, setOtevrena] = useState<string | null>(vychozi ?? null);

  return (
    <div className="sm:hidden border-b border-white/10 pb-4">
      <nav className="pt-2">
        <MobilOdkaz to="/search/model" onZavri={onZavri} ikona={<MotorcycleIcon size={18} />}>
          Model
        </MobilOdkaz>
        <MobilOdkaz to="/search/part" onZavri={onZavri} ikona={<HashIcon size={18} />}>
          Číslo dílu
        </MobilOdkaz>

        {CATALOG.map((skupina) => (
          <MobilSkupina
            key={skupina.label}
            nadpis={skupina.label}
            pocet={skupina.items.length}
            otevrena={otevrena === skupina.label}
            onPrepni={() =>
              setOtevrena((o) => (o === skupina.label ? null : skupina.label))}
          >
            {skupina.items.map((i) => (
              <MobilOdkaz key={i.to} to={i.to} onZavri={onZavri} popis={i.hint}>
                {i.label}
              </MobilOdkaz>
            ))}
          </MobilSkupina>
        ))}

        <MobilSkupina
          nadpis="Provoz"
          pocet={PROVOZ.length}
          otevrena={otevrena === "Provoz"}
          onPrepni={() => setOtevrena((o) => (o === "Provoz" ? null : "Provoz"))}
        >
          {PROVOZ.map((i) => (
            <MobilOdkaz key={i.to} to={i.to} onZavri={onZavri} ikona={i.icon} popis={i.hint}>
              {i.label}
            </MobilOdkaz>
          ))}
        </MobilSkupina>
      </nav>

      {/* Přepínače — na mobilu pod sebou, ať mají na co ťuknout. */}
      <div className="mt-4 pt-4 border-t border-white/10 space-y-3">
        <MobilRadek popis="Jazyk">
          <LocaleToggle />
        </MobilRadek>
        <MobilRadek popis="Měna">
          <CurrencyToggle />
        </MobilRadek>
        <MobilRadek popis="Ceny">
          <VatToggle />
        </MobilRadek>
      </div>

      {user && (
        <div className="mt-4 pt-4 border-t border-white/10 flex items-center justify-between gap-3">
          <div className="min-w-0">
            <div className="text-sm text-zinc-200 truncate">{user.name ?? user.id}</div>
            <div className="text-xs text-zinc-500 capitalize">{user.role}</div>
          </div>
          {authEnabled && (
            <button
              type="button"
              onClick={() => void onLogout()}
              className="shrink-0 h-11 px-4 rounded-lg text-sm text-red-400 hover:bg-white/10 active:bg-white/20 transition-colors"
            >
              Odhlásit se
            </button>
          )}
        </div>
      )}
    </div>
  );
}

/**
 * Sbalitelná skupina mobilního menu.
 *
 * ⚠ Nadpis je TLAČÍTKO, ne jen text — na mobilu se do menu ťuká prstem
 * a `min-h-11` (44 px) je nejmenší plocha, na kterou se dá spolehlivě trefit.
 *
 * ⛔ Sbalené položky se do stromu vůbec nevykreslují (ne `display:none`) —
 * jinak by pod nimi zůstala výška a celý smysl sbalení by padl.
 */
function MobilSkupina({
  nadpis,
  pocet,
  otevrena,
  onPrepni,
  children,
}: {
  nadpis: string;
  pocet: number;
  otevrena: boolean;
  onPrepni: () => void;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={onPrepni}
        aria-expanded={otevrena}
        className="w-full min-h-11 px-3 flex items-center justify-between gap-2 rounded-lg text-left active:bg-white/10 transition-colors"
      >
        <span className="text-[11px] uppercase tracking-wider text-zinc-400 font-medium">
          {nadpis}
          <span className="ml-2 text-zinc-500 normal-case tracking-normal">{pocet}</span>
        </span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
             className={`text-zinc-500 shrink-0 transition-transform ${otevrena ? "rotate-180" : ""}`}>
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {otevrena && <div className="mt-0.5">{children}</div>}
    </div>
  );
}

/** ⚠ `min-h-11` = 44 px, doporučená klikací plocha na dotykovém displeji. */
function MobilOdkaz({
  to,
  children,
  ikona,
  popis,
  onZavri,
}: {
  to: string;
  children: React.ReactNode;
  ikona?: React.ReactNode;
  popis?: string | undefined;
  onZavri: () => void;
}): JSX.Element {
  return (
    <NavLink
      to={to}
      onClick={onZavri}
      className={({ isActive }) =>
        `flex items-center gap-3 min-h-11 px-3 py-2 rounded-lg transition-colors ${
          isActive ? "bg-white/10 text-white" : "text-zinc-300 active:bg-white/10"
        }`
      }
    >
      {ikona && <span className="text-zinc-500 shrink-0">{ikona}</span>}
      <span className="min-w-0">
        <span className="block text-sm">{children}</span>
        {popis && <span className="block text-xs text-zinc-500 truncate">{popis}</span>}
      </span>
    </NavLink>
  );
}

function MobilRadek({
  popis,
  children,
}: {
  popis: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <div className="flex items-center justify-between gap-3 px-3">
      <span className="text-xs text-zinc-500">{popis}</span>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

function NotFound(): JSX.Element {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 text-center">
      <h1 className="text-3xl font-semibold text-zinc-900">Stránka nenalezena</h1>
      <p className="mt-2 text-zinc-500">Zkuste začít z domovské stránky.</p>
      <Link
        to="/"
        className="mt-6 inline-block text-ktm-orange hover:underline"
      >
        Domů
      </Link>
    </div>
  );
}

function Footer(): JSX.Element {
  return (
    <footer className="border-t border-zinc-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between text-xs text-zinc-500">
        <div>KTM Vlašim · Interní katalog dílů</div>
        <div className="flex gap-4">
          <span>Data synchronizována z KTM BFF</span>
        </div>
      </div>
    </footer>
  );
}
